module.exports = __webpack_public_path__ + "static/media/AB_B2_6.e5ccd597.JPG";